// extracted by mini-css-extract-plugin
module.exports = {"starterKit":"starterKit_starterKit__kS9zO"};